import st from './panels.module.scss'

const Panels = (props) => {
	return <div className={st.wrapper}>{props.children}</div>
}

export default Panels
